[
  {
    "rank": 1,
    "slug": "gates-of-olympus",
    "name": "Gates of Olympus",
    "provider": "Pragmatic Play",
    "rtp": 96.5,
    "volatility": "Hoog",
    "maxWin": "5.000x",
    "release": 2021,
    "score": 9.4,
    "reels": "6x5",
    "mechanic": "Pay Anywhere · tumble",
    "minBet": 0.2,
    "maxBet": 100,
    "color": "#3B3F9E",
    "theme": "myth",
    "demoSymbol": "vs20olympgate",
    "verdict": "De ongekroonde koning van Nieuw-Zeeland: Zeus strooit willekeurige multipliers tot 500x en elke tumble kan een ronde volledig omgooien.",
    "features": ["Multipliers tot 500x", "15 free spins met cumulatieve multiplier", "Ante bet voor dubbele scatterkans"]
  },
  {
    "rank": 2,
    "slug": "book-of-dead",
    "name": "Book of Dead",
    "provider": "Play'n GO",
    "rtp": 96.21,
    "volatility": "Hoog",
    "maxWin": "5.000x",
    "release": 2016,
    "score": 9.3,
    "reels": "5x3",
    "mechanic": "10 paylines · uitbreidend symbool",
    "minBet": 0.1,
    "maxBet": 100,
    "color": "#8A5A1F",
    "theme": "book",
    "demoUrl": "https://asicw.playngonetwork.com/casino/ContainerLauncher?pid=2&gid=bookofdead&lang=en_GB&channel=desktop&practice=1&demo=2",
    "verdict": "Eenvoudig, spannend en tijdloos: het uitbreidende symbool in de free spins blijft de reden dat Kiwi’s en Nederlanders massaal terugkeren.",
    "features": ["Uitbreidend speciaal symbool", "10 free spins, herstartbaar", "Gamble-functie op winsten"]
  },
  {
    "rank": 3,
    "slug": "sweet-bonanza",
    "name": "Sweet Bonanza",
    "provider": "Pragmatic Play",
    "rtp": 96.48,
    "volatility": "Hoog",
    "maxWin": "21.100x",
    "release": 2019,
    "score": 9.2,
    "reels": "6x5",
    "mechanic": "Pay Anywhere · tumble",
    "minBet": 0.2,
    "maxBet": 125,
    "color": "#C2336F",
    "theme": "candy",
    "demoSymbol": "vs20fruitsw",
    "verdict": "Kleurrijk en ronduit explosief: de bom-multipliers in de bonus maken van een rustige spin in één klap een topwinst.",
    "features": ["Tumble-wins op elke spin", "Bom-multipliers tot 100x", "Bonus buy beschikbaar"]
  },
  {
    "rank": 4,
    "slug": "pirots-4",
    "name": "Pirots 4",
    "provider": "ELK Studios",
    "rtp": 96.0,
    "volatility": "Hoog",
    "maxWin": "10.000x",
    "release": 2025,
    "score": 9.1,
    "reels": "6x6 → 8x8",
    "mechanic": "Cascades · verzamelmechaniek",
    "minBet": 0.2,
    "maxBet": 100,
    "color": "#2E7D6B",
    "theme": "bird",
    "verdict": "ELK’s eigenzinnige vogels verzamelen edelstenen over een groeiend speelveld — de meest originele slot in onze top 10.",
    "features": ["Speelveld groeit tot 8x8", "Vogels verzamelen symbolen", "Lost in Space-bonus"]
  },
  {
    "rank": 5,
    "slug": "legacy-of-dead",
    "name": "Legacy of Dead",
    "provider": "Play'n GO",
    "rtp": 96.58,
    "volatility": "Hoog",
    "maxWin": "5.000x",
    "release": 2020,
    "score": 9.0,
    "reels": "5x3",
    "mechanic": "10 paylines · uitbreidende symbolen",
    "minBet": 0.1,
    "maxBet": 100,
    "color": "#5B3A8C",
    "theme": "egypt",
    "demoUrl": "https://asicw.playngonetwork.com/casino/ContainerLauncher?pid=2&gid=legacyofdead&lang=en_GB&channel=desktop&practice=1&demo=2",
    "verdict": "De logische opvolger van Book of Dead, met meerdere uitbreidende symbolen tegelijk en een iets hogere RTP.",
    "features": ["Meerdere uitbreidende symbolen", "Bonusspins herstartbaar", "RTP tot 96,58%"]
  },
  {
    "rank": 6,
    "slug": "starburst",
    "name": "Starburst",
    "provider": "NetEnt",
    "rtp": 96.09,
    "volatility": "Laag",
    "maxWin": "500x",
    "release": 2012,
    "score": 8.9,
    "reels": "5x3",
    "mechanic": "10 paylines · beide richtingen",
    "minBet": 0.1,
    "maxBet": 100,
    "color": "#2A3F8F",
    "theme": "gem",
    "verdict": "Lage volatiliteit, snelle hits en uitbetalingen in twee richtingen: dé slot voor wie ontspannen wil spelen.",
    "features": ["Expanding wilds met respin", "Winlijnen in twee richtingen", "Geschikt voor kleine inzetten"]
  },
  {
    "rank": 7,
    "slug": "gates-of-olympus-1000",
    "name": "Gates of Olympus 1000",
    "provider": "Pragmatic Play",
    "rtp": 96.5,
    "volatility": "Zeer hoog",
    "maxWin": "15.000x",
    "release": 2023,
    "score": 8.9,
    "reels": "6x5",
    "mechanic": "Pay Anywhere · tumble",
    "minBet": 0.2,
    "maxBet": 100,
    "color": "#7A2E8E",
    "theme": "myth",
    "demoSymbol": "vs20olympx",
    "verdict": "Dezelfde Zeus, maar met multipliers tot 1000x en een maximale winst die drie keer zo hoog ligt als het origineel.",
    "features": ["Multipliers tot 1000x", "Max. winst 15.000x", "Free spins met cumulatieve multiplier"]
  },
  {
    "rank": 8,
    "slug": "big-bass-bonanza",
    "name": "Big Bass Bonanza",
    "provider": "Pragmatic Play",
    "rtp": 96.71,
    "volatility": "Hoog",
    "maxWin": "2.100x",
    "release": 2020,
    "score": 8.8,
    "reels": "5x3",
    "mechanic": "10 paylines · money collect",
    "minBet": 0.1,
    "maxBet": 250,
    "color": "#1F6FA8",
    "theme": "fish",
    "demoSymbol": "vs10bbbonanza",
    "verdict": "De visser verzamelt geldsymbolen in de free spins — eenvoudig concept, verslavend goed uitgewerkt.",
    "features": ["Visser verzamelt geldvissen", "Retrigger met hogere multipliers", "RTP tot 96,71%"]
  },
  {
    "rank": 9,
    "slug": "sugar-rush",
    "name": "Sugar Rush",
    "provider": "Pragmatic Play",
    "rtp": 96.5,
    "volatility": "Hoog",
    "maxWin": "5.000x",
    "release": 2022,
    "score": 8.7,
    "reels": "7x7",
    "mechanic": "Cluster pays · multiplier-vakjes",
    "minBet": 0.2,
    "maxBet": 100,
    "color": "#A8325E",
    "theme": "candy",
    "demoSymbol": "vs20sugarrush",
    "verdict": "Clusterwins laten vakjes oplichten met groeiende multipliers tot 128x — kleurrijk, maar met tanden.",
    "features": ["Multiplier-vakjes tot 128x", "Cluster pays op 7x7 grid", "Tot 30 free spins"]
  },
  {
    "rank": 10,
    "slug": "gonzos-quest",
    "name": "Gonzo’s Quest",
    "provider": "NetEnt",
    "rtp": 95.97,
    "volatility": "Gemiddeld",
    "maxWin": "2.500x",
    "release": 2011,
    "score": 8.7,
    "reels": "5x3",
    "mechanic": "20 paylines · Avalanche",
    "minBet": 0.2,
    "maxBet": 50,
    "color": "#4C7A2A",
    "theme": "jungle",
    "verdict": "De slot die de Avalanche-mechaniek populair maakte. Na vijftien jaar nog steeds een klassieker.",
    "features": ["Avalanche-reels", "Multipliers tot 15x in Free Falls", "Toegankelijke inzetten"]
  },
  {
    "rank": 11,
    "slug": "big-bass-splash",
    "name": "Big Bass Splash",
    "provider": "Pragmatic Play",
    "rtp": 96.71,
    "volatility": "Hoog",
    "maxWin": "5.000x",
    "release": 2022,
    "score": 8.6,
    "reels": "5x3",
    "mechanic": "10 paylines · random modifiers",
    "minBet": 0.1,
    "maxBet": 250,
    "color": "#16708C",
    "theme": "fish",
    "demoSymbol": "vs10txbigbass",
    "verdict": "Big Bass met willekeurige modifiers vóór de free spins en een maximale winst van 5.000x.",
    "features": ["Willekeurige pre-bonus modifiers", "Visser verzamelt geldvissen", "Max. winst 5.000x"]
  },
  {
    "rank": 12,
    "slug": "reactoonz",
    "name": "Reactoonz",
    "provider": "Play'n GO",
    "rtp": 96.51,
    "volatility": "Hoog",
    "maxWin": "4.570x",
    "release": 2017,
    "score": 8.5,
    "reels": "7x7",
    "mechanic": "Cluster pays · Quantum features",
    "minBet": 0.2,
    "maxBet": 100,
    "color": "#3C7E3A",
    "theme": "space",
    "demoUrl": "https://asicw.playngonetwork.com/casino/ContainerLauncher?pid=2&gid=reactoonz&lang=en_GB&channel=desktop&practice=1&demo=2",
    "verdict": "Chaotisch in de beste zin: buitenaardse wezentjes, cluster pays en een Gargantoon die het hele scherm kan vullen.",
    "features": ["Quantum Leap-modifiers", "Gargantoon-wilds", "Cluster pays op 7x7"]
  },
  {
    "rank": 13,
    "slug": "wanted-dead-or-a-wild",
    "name": "Wanted Dead or a Wild",
    "provider": "Hacksaw Gaming",
    "rtp": 96.38,
    "volatility": "Zeer hoog",
    "maxWin": "12.500x",
    "release": 2021,
    "score": 8.5,
    "reels": "5x5",
    "mechanic": "15 paylines · VS-symbolen",
    "minBet": 0.2,
    "maxBet": 100,
    "color": "#8C3B24",
    "theme": "western",
    "verdict": "Hacksaw’s westernhit met drie bonusmodi en multipliers die tot 100x kunnen oplopen. Niets voor wie een rustige sessie zoekt.",
    "features": ["Drie verschillende bonusrondes", "VS-wilds met multipliers tot 100x", "Max. winst 12.500x"]
  },
  {
    "rank": 14,
    "slug": "money-train-4",
    "name": "Money Train 4",
    "provider": "Relax Gaming",
    "rtp": 96.1,
    "volatility": "Zeer hoog",
    "maxWin": "150.000x",
    "release": 2023,
    "score": 8.4,
    "reels": "5x4",
    "mechanic": "Respin · persistente symbolen",
    "minBet": 0.1,
    "maxBet": 50,
    "color": "#2F4858",
    "theme": "train",
    "verdict": "Een respin-bonus vol persistente symbolen die elkaar versterken — met de hoogste maximale winst in onze lijst.",
    "features": ["Money Cart-respins", "Persistente special symbols", "Max. winst 150.000x"]
  },
  {
    "rank": 15,
    "slug": "dead-or-alive-2",
    "name": "Dead or Alive 2",
    "provider": "NetEnt",
    "rtp": 96.82,
    "volatility": "Zeer hoog",
    "maxWin": "111.111x",
    "release": 2019,
    "score": 8.4,
    "reels": "5x3",
    "mechanic": "9 paylines · sticky wilds",
    "minBet": 0.09,
    "maxBet": 18,
    "color": "#6E4A1E",
    "theme": "western",
    "verdict": "Drie bonusmodi met sticky wilds; de High Noon Saloon blijft een van de meest gevreesde én geliefde features ooit.",
    "features": ["Drie bonusmodi", "Sticky wilds in free spins", "Max. winst 111.111x"]
  },
  {
    "rank": 16,
    "slug": "rise-of-olympus",
    "name": "Rise of Olympus",
    "provider": "Play'n GO",
    "rtp": 96.5,
    "volatility": "Hoog",
    "maxWin": "5.000x",
    "release": 2018,
    "score": 8.3,
    "reels": "5x5",
    "mechanic": "Cascades · godenkrachten",
    "minBet": 0.2,
    "maxBet": 100,
    "color": "#2C5C8F",
    "theme": "thunder",
    "demoUrl": "https://asicw.playngonetwork.com/casino/ContainerLauncher?pid=2&gid=riseofolympus&lang=en_GB&channel=desktop&practice=1&demo=2",
    "verdict": "Drie Griekse goden met elk een eigen kracht op een 5x5-grid — de Play’n GO-tegenhanger van Gates of Olympus.",
    "features": ["Drie godenkrachten", "Cascading wins", "Free spins met drie modi"]
  },
  {
    "rank": 17,
    "slug": "starlight-princess",
    "name": "Starlight Princess",
    "provider": "Pragmatic Play",
    "rtp": 96.5,
    "volatility": "Hoog",
    "maxWin": "5.000x",
    "release": 2021,
    "score": 8.3,
    "reels": "6x5",
    "mechanic": "Pay Anywhere · tumble",
    "minBet": 0.2,
    "maxBet": 100,
    "color": "#A8407E",
    "theme": "princess",
    "demoSymbol": "vs20starlight",
    "verdict": "Anime-stijl met hetzelfde wiskundige hart als Gates of Olympus — ideaal als je die formule in een andere jas wilt.",
    "features": ["Multipliers tot 500x", "Tumble-wins", "Bonus buy beschikbaar"]
  },
  {
    "rank": 18,
    "slug": "le-bandit",
    "name": "Le Bandit",
    "provider": "Hacksaw Gaming",
    "rtp": 96.34,
    "volatility": "Hoog",
    "maxWin": "10.000x",
    "release": 2023,
    "score": 8.2,
    "reels": "6x5",
    "mechanic": "Cluster pays · Golden Squares",
    "minBet": 0.1,
    "maxBet": 100,
    "color": "#2B6E5B",
    "theme": "jackpot",
    "verdict": "Een wasbeer als meesterdief en gouden vakjes die bonussymbolen activeren — fris, grappig en verrassend volatiel.",
    "features": ["Golden Squares", "Rainbow-symbolen", "Twee bonusrondes"]
  },
  {
    "rank": 19,
    "slug": "pirots-3",
    "name": "Pirots 3",
    "provider": "ELK Studios",
    "rtp": 96.0,
    "volatility": "Hoog",
    "maxWin": "10.000x",
    "release": 2024,
    "score": 8.1,
    "reels": "6x6",
    "mechanic": "Cascades · verzamelmechaniek",
    "minBet": 0.2,
    "maxBet": 100,
    "color": "#3E7A9C",
    "theme": "bird",
    "verdict": "Het derde Pirots-deel, met een treinmechaniek die edelstenen ophaalt. Iets voorspelbaarder dan deel 4.",
    "features": ["Verzamelende vogels", "Uitbreidend speelveld", "Bonusspel met trein"]
  },
  {
    "rank": 20,
    "slug": "fire-in-the-hole-3",
    "name": "Fire in the Hole 3",
    "provider": "Nolimit City",
    "rtp": 96.06,
    "volatility": "Zeer hoog",
    "maxWin": "70.000x",
    "release": 2024,
    "score": 8.0,
    "reels": "6x6",
    "mechanic": "xBomb · Lucky Wagon",
    "minBet": 0.2,
    "maxBet": 100,
    "color": "#5A3B28",
    "theme": "mine",
    "demoUrl": "https://partner.nolimitcdn.com/loader/game-loader.html?game=FireInTheHole3&operator=SMOOTHOPERATOR&language=en&device=desktop",
    "verdict": "Nolimit City op z’n wildst: xBomb-wilds, mijnwagens en een maximale winst van 70.000x. Speel alleen met een strak budget.",
    "features": ["xBomb-wilds", "Lucky Wagon-spins", "Max. winst 70.000x"]
  },
  {
    "rank": 21,
    "slug": "moon-princess",
    "name": "Moon Princess",
    "provider": "Play'n GO",
    "rtp": 96.5,
    "volatility": "Hoog",
    "maxWin": "5.000x",
    "release": 2017,
    "score": 8.0,
    "reels": "5x5",
    "mechanic": "Cascades · Girl Power",
    "minBet": 0.2,
    "maxBet": 100,
    "color": "#4A3C8C",
    "theme": "princess",
    "demoUrl": "https://asicw.playngonetwork.com/casino/ContainerLauncher?pid=2&gid=moonprincess&lang=en_GB&channel=desktop&practice=1&demo=2",
    "verdict": "Drie prinsessen met elk een eigen kracht en een Girl Power-free spins-ronde met groeiende multiplier.",
    "features": ["Drie prinsessenkrachten", "Girl Power free spins", "Cascading wins"]
  },
  {
    "rank": 22,
    "slug": "chaos-crew-2",
    "name": "Chaos Crew 2",
    "provider": "Hacksaw Gaming",
    "rtp": 96.3,
    "volatility": "Zeer hoog",
    "maxWin": "25.000x",
    "release": 2023,
    "score": 7.9,
    "reels": "5x5",
    "mechanic": "Multipliers · symbooltransformatie",
    "minBet": 0.1,
    "maxBet": 100,
    "color": "#A0332E",
    "theme": "horror",
    "verdict": "Brutale cartoonstijl en multiplier-symbolen die tot 25.000x kunnen leiden. Pure Hacksaw.",
    "features": ["Multiplier-symbolen", "Twee bonusrondes", "Max. winst 25.000x"]
  },
  {
    "rank": 23,
    "slug": "bonanza-megaways",
    "name": "Bonanza Megaways",
    "provider": "Big Time Gaming",
    "rtp": 96.0,
    "volatility": "Hoog",
    "maxWin": "10.000x",
    "release": 2016,
    "score": 7.9,
    "reels": "6 rollen",
    "mechanic": "Megaways · tot 117.649 manieren",
    "minBet": 0.2,
    "maxBet": 40,
    "color": "#6B4E2A",
    "theme": "mine",
    "verdict": "De slot die Megaways op de kaart zette — tot 117.649 winmanieren en onbeperkte multipliers in de free spins.",
    "features": ["Tot 117.649 winmanieren", "Reactions met cascades", "Onbeperkte win-multiplier"]
  },
  {
    "rank": 24,
    "slug": "wolf-gold",
    "name": "Wolf Gold",
    "provider": "Pragmatic Play",
    "rtp": 96.01,
    "volatility": "Gemiddeld",
    "maxWin": "2.500x",
    "release": 2017,
    "score": 7.8,
    "reels": "5x3",
    "mechanic": "25 paylines · Money Respin",
    "minBet": 0.25,
    "maxBet": 125,
    "color": "#8C5A1A",
    "theme": "wolf",
    "demoSymbol": "vs25wolfgold",
    "verdict": "Rustiger dan de rest van Pragmatic’s top: gemiddelde volatiliteit met drie vaste jackpots in de Money Respin.",
    "features": ["Drie vaste jackpots", "Money Respin", "Giant symbols in free spins"]
  },
  {
    "rank": 25,
    "slug": "elvis-frog-in-vegas",
    "name": "Elvis Frog in Vegas",
    "provider": "BGaming",
    "rtp": 96.0,
    "volatility": "Gemiddeld",
    "maxWin": "2.500x",
    "release": 2020,
    "score": 7.8,
    "reels": "5x3",
    "mechanic": "25 paylines · coin respins",
    "minBet": 0.25,
    "maxBet": 125,
    "color": "#1E7A5A",
    "theme": "frog",
    "demoUrl": "https://demo.bgaming-network.com/play/ElvisFrogInVegas/FUN?server=demo",
    "verdict": "Een kikker met Elvis-kuif en een coin-respin met jackpots — luchtig, goed op mobiel en verrassend diep.",
    "features": ["Coin respins met jackpots", "Free spins met sticky wilds", "Bonus buy"]
  },
  {
    "rank": 26,
    "slug": "mega-moolah",
    "name": "Mega Moolah",
    "provider": "Games Global",
    "rtp": 88.12,
    "volatility": "Gemiddeld",
    "maxWin": "Progressief",
    "release": 2006,
    "score": 7.7,
    "reels": "5x3",
    "mechanic": "25 paylines · progressieve jackpot",
    "minBet": 0.25,
    "maxBet": 6.25,
    "color": "#9A5E16",
    "theme": "jackpot",
    "verdict": "Lage RTP, maar dit is de slot van de recordjackpots. Speel hem voor het jackpotwiel, niet voor de basisgame.",
    "features": ["Vier progressieve jackpots", "Jackpotwiel", "Free spins met 3x multiplier"]
  },
  {
    "rank": 27,
    "slug": "thunderstruck-ii",
    "name": "Thunderstruck II",
    "provider": "Games Global",
    "rtp": 96.65,
    "volatility": "Gemiddeld",
    "maxWin": "8.000x",
    "release": 2010,
    "score": 7.6,
    "reels": "5x3",
    "mechanic": "243 manieren · Great Hall of Spins",
    "minBet": 0.3,
    "maxBet": 60,
    "color": "#2D4A7A",
    "theme": "thunder",
    "verdict": "Een klassieker met de Great Hall of Spins: vier goden-bonussen die je stap voor stap vrijspeelt.",
    "features": ["Great Hall of Spins", "Wildstorm-feature", "243 winmanieren"]
  },
  {
    "rank": 28,
    "slug": "jammin-jars",
    "name": "Jammin’ Jars",
    "provider": "Push Gaming",
    "rtp": 96.83,
    "volatility": "Hoog",
    "maxWin": "20.000x",
    "release": 2018,
    "score": 7.6,
    "reels": "8x8",
    "mechanic": "Cluster pays · wandelende wilds",
    "minBet": 0.2,
    "maxBet": 100,
    "color": "#A23A72",
    "theme": "fruit",
    "verdict": "Dansende jampotten met groeiende multipliers op een 8x8-grid. Hoge RTP, hoge spanning.",
    "features": ["Wandelende Jar-wilds", "Groeiende multipliers", "Rainbow-feature"]
  },
  {
    "rank": 29,
    "slug": "mental",
    "name": "Mental",
    "provider": "Nolimit City",
    "rtp": 96.08,
    "volatility": "Zeer hoog",
    "maxWin": "66.666x",
    "release": 2021,
    "score": 7.5,
    "reels": "5 rollen",
    "mechanic": "xWays · xSplit",
    "minBet": 0.2,
    "maxBet": 100,
    "color": "#45474A",
    "theme": "horror",
    "demoUrl": "https://partner.nolimitcdn.com/loader/game-loader.html?game=Mental&operator=SMOOTHOPERATOR&language=en&device=desktop",
    "verdict": "Donker, provocerend en extreem volatiel. Niet voor iedereen, maar mechanisch een van de knapste slots van het decennium.",
    "features": ["xWays- en xSplit-wilds", "Fire Wilds", "Max. winst 66.666x"]
  },
  {
    "rank": 30,
    "slug": "twin-spin",
    "name": "Twin Spin",
    "provider": "NetEnt",
    "rtp": 96.6,
    "volatility": "Gemiddeld",
    "maxWin": "1.080x",
    "release": 2013,
    "score": 7.4,
    "reels": "5x3",
    "mechanic": "243 manieren · Twin Reels",
    "minBet": 0.25,
    "maxBet": 125,
    "color": "#9C2F3A",
    "theme": "fruit",
    "verdict": "Een retro fruitslot met gekoppelde rollen die zich op elke spin kunnen uitbreiden. Laagdrempelig en snel.",
    "features": ["Gekoppelde Twin Reels", "243 winmanieren", "Klassieke fruitsymbolen"]
  }
]
